import { object, string } from "yup";
export { deathNotificationStatus } from "@thalamos/common";
export const BasePatientDemographicsSchema = object({
    name: object({
        given: string().required(),
        family: string().required(),
    }).required(),
    address: object({
        address: string().required(),
        postalCode: string().required(),
    }).required(),
    dateOfBirth: string().nullable().optional(),
});
//# sourceMappingURL=patient.js.map